import * as React from "react";
import {Fragment} from "react";
import {Col, Row} from "reactstrap";

export default class RedemptionResponseComponent extends React.Component {

    constructor(props) {
        super(props);

        this.className = this.props.className;

        this.state = {
            lookupResponse: this.props.lookupResponse || {}
        }
    }

    componentDidMount() {

        if (this.props.setHeader)
            this.props.setHeader();
    }

    render() {

        return <Fragment>
            <div className={this.className + "_quote_display"}>
                <Row className={this.className + "_quote_display_row"} style={{padding: "0 30px 0 30px"}}>
                    <Col >
                        <Row >
                            <Col xs={6} className={this.className + "_titles_in"}>Sender Name&nbsp;:</Col>
                            <Col xs={6} className={this.className + "_values_in"}>{this.state.lookupResponse.customerFirstName+' '+this.state.lookupResponse.customerLastName}</Col>
                        </Row>
                        <Row >
                            <Col xs={6} className={this.className + "_titles_in"}>Sender Country&nbsp;: </Col>
                            <Col xs={6} className={this.className + "_values_in"}>{this.state.lookupResponse.countryFrom}</Col>
                        </Row>
                        <Row >
                            <Col xs={6} className={this.className + "_titles_in"}>Beneficiary Name&nbsp;:</Col>
                            <Col xs={6} className={this.className + "_values_in"}>{this.state.lookupResponse.beneficiaryFirstName+' '+this.state.lookupResponse.beneficiaryLastName}</Col>
                        </Row>
                        <Row >
                            <Col xs={6} className={this.className + "_titles_in"}>Beneficiary Cell&nbsp;:</Col>
                            <Col xs={6} className={this.className + "_values_in"}>{this.state.lookupResponse.beneficiaryMsisdn}</Col>
                        </Row>
                        <hr/>
                        <Row >
                            <Col xs={6} className={this.className + "_titles_in"}>Transaction Type&nbsp;:</Col>
                            <Col xs={6} className={this.className + "_values_in"}>{this.state.lookupResponse.transactionTypeDisplayValue}</Col>
                        </Row>
                        <Row >
                            <Col xs={6} className={this.className + "_titles_in"}>Amount&nbsp;:</Col>
                            <Col xs={6} className={this.className + "_values_in"}>{this.state.lookupResponse.beneficiaryCurrency+' '+this.state.lookupResponse.beneficiaryAmount}</Col>
                        </Row>
                    </Col>
                </Row>
            </div>

        </Fragment>
    }

}